import React, { useState } from 'react'

import { IMAGE } from '@ui-kit/assets/images/index.web'
import Icon from '@ui-kit/components/SvgIcon/index.web'
import { tableCategoryAccordion } from '@ui-kit/components/Table/TableCategoryAccordion/styles'
import TableCategoryAccordionContent from '@ui-kit/components/Table/TableCategoryAccordionContent/index.web'
import type { TableCategoryRow } from '@ui-kit/components/Table/types'

interface Props {
  categoryRow: TableCategoryRow
  isLast: boolean
  onItemToggle?: (key: string, isExpanded: boolean) => void
}

const TableCategoryAccordion = (props: Props) => {
  const [isExpanded, setIsExpanded] = useState(props.categoryRow.isExpandedByDefault)
  const { row, title, icon } = tableCategoryAccordion({ isLast: props.isLast, isExpanded })

  const handleClick = () => {
    setIsExpanded(!isExpanded)
    props.onItemToggle?.(props.categoryRow.key, isExpanded)
  }

  return (
    <div>
      <div className={row()} onClick={handleClick}>
        <div className={title()}>{props.categoryRow.title}</div>
        <div className={icon()}>
          <Icon className={icon()} imgSrc={IMAGE.icons.xsmall.action.chevronDown_16} />
        </div>
      </div>

      {isExpanded &&
        props.categoryRow.rows.map((r, rowIndex) => (
          <TableCategoryAccordionContent key={r.key} rowContent={r} isFirst={rowIndex === 0} />
        ))}
    </div>
  )
}

export default TableCategoryAccordion
